package pwgs.ui.scenes.generalsettingsscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.Card
import visage.ds.components.Table

class MGeneralSettingsScene(props: GeneralSettingsSceneProps) : AScene<GeneralSettingsSceneProps, GeneralSettingsSceneModel, GeneralSettingsSceneState, GeneralSettingsControllerFe>(props) {

    override fun createController() : GeneralSettingsControllerFe {
        return GeneralSettingsControllerFe(props, this)
    }

    override fun initState() : GeneralSettingsSceneState {
        return GeneralSettingsSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        var m = this@MGeneralSettingsScene.model
        Card {
            isLoading = m.isLoading
            header(title = "API Keys")

            body {
                Table {
                    columns {
                        fixedColumn("Type")
                        fixedColumn("Key")
                    }

                    body {
                        row {
                            cell("Client")
                            cell(m.clientApiKey)
                        }
                        row {
                            cell("Server")
                            cell(m.serverApiKey)
                        }
                    }
                }
            }
        }
    }
}

class GeneralSettingsSceneState {

}

fun Components.GeneralSettingsScene(props: GeneralSettingsSceneProps) = this.registerComponent(MGeneralSettingsScene(props), {})
